import { css } from '@/styled-system/css';

export const fieldSetStyles = css.raw({
  '& > .c11n_legend': {
    display: 'block',
    marginBlockEnd: 'tightest',
  },

  /*
   * The tooltip is rendered inside the legend rather than beside it, because a
   * fieldset lifts its rendered legend out of its own layout box. Flex ordering
   * moves the trigger past the required/optional marker, which is an `::after`
   * pseudo-element and is therefore always last in DOM order.
   */
  '& > .c11n_legend:has(> .c11n_tooltip__trigger)': {
    'alignItems': 'center',
    'display': 'flex',

    '& > .c11n_tooltip__trigger': {
      marginInlineStart: 'micro.default',
      order: 1,
    },
  },

  '& > .c11n_form-help': {
    marginBlockStart: 'tightest',
  },

  /*
   * Indent labeled controls only if a legend is present.
   * Using base style instead of variant to ensure this works for composed version.
   */
  '& > .c11n_legend ~ .c11n_labeled-control': {
    marginInlineStart: 'tighter',
  },

  /*
   * Hide redundant 'required' and 'optional' indicators in labeled controls.
   */
  '& > .c11n_labeled-control > .c11n_label:after': {
    content: 'none',
  },
});
